import { JSXElement } from '@/common/types';
import { ErrorProps } from './types';

export function Error({ message }: ErrorProps): JSXElement {
    return <h3>{message ? message : 'Encountered an unexpected error'}</h3>;
}
